import { useContext, useEffect, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import DashboardContext from "../../Context";
import ModalDelete from "./ModalDelete";
import ModalPaid from "./ModalPaid";
import PropTypes from 'prop-types';
import ModalConfermWorker from "./tabelWorker/ModalConfermWorker";
import ModalPriceList from "./tabelWorker/ModalPriceList";

export default function Tabelrowbody({ item, number, handeldeleteitem, handelModalepaid, page, arryheder, urldata, arryactions, accordionTable }) {

    const { accessPage, handelEdit, handelAdd, handelIdview, handelloding, handeldmicro } = useContext(DashboardContext);

    const [keyarry, setKeyarry] = useState([])

    const [moreitem, setMoreitem] = useState(false)

    const [show, setShow] = useState(false);

    const [showPiad, setShowPiad] = useState(false);

    const handleClose = () => setShow(false);

    const handleShow = () => setShow(true)

    const handeldelete = () => {
        handeldeleteitem()
        handleClose()
    }

    const handelShowpaid = () => setShowPiad(true)

    const handelClosePaid = () => setShowPiad(false)

    const handelPaiditem = () => {
        handelClosePaid()
    }

    const [showBoxacces, setshowBoxacces] = useState(false);


    useEffect(() => {

        setshowBoxacces(arryactions ? arryactions.length > 1 ? true : false : accessPage ? accessPage.length > 1 ? true : false : false)


        if (item) {
            setKeyarry(Object.values(item))
        }
        // if (item) {
        //     let mytd = []
        //     for (const property in item) {
        //         if (item[property] === item.id) {

        //         }

        //         else {

        //             mytd.push(item[property])
        //         }

        //     }
        //     setKeyarry(mytd)
        // }
        return () => {

        }
    }, [])


    const handelEditbtn = (id) => {
        if(!accordionTable) handelAdd(true)
        if (urldata) {
            handeldmicro(true)
            handelEdit(id)
        }
        else {
            handelAdd(true)
        }
        handelEdit(id)
        handelloding(true)
    }

    const handelview = id => {

        handelIdview(id)
        handelloding(true)

    }


    const handelCopy = (name) => {
        navigator.clipboard.writeText(name)
    }

    /**مدال تایید نیرو */
    const [showmodalConferm, setShowmodalConferm] = useState(false)
    const showConfermWorkerModal = () => setShowmodalConferm(true)
    const closeConfermWokerModal = () => setShowmodalConferm(false)

    const [showModalPriceList, setShowModalPriceList] = useState(false);
    const handelShowModalPriceList = () => setShowModalPriceList(true);
    const handelHideModalPriceList = () => setShowModalPriceList(false);

    return (
        <>
            <tr>
                <td className='morerow' >
                    {
                        keyarry.length > 0 ?
                            keyarry.length > 10 ?
                                <span onClick={() => setMoreitem(!moreitem)} className='ml-2' >
                                    {moreitem ? <i className="mdi mdi-arrow-up-bold-circle"></i> :
                                        <i className="mdi mdi-arrow-down-bold-circle"></i>}
                                </span>
                                : null
                            : null
                    }
                    {
                        showBoxacces ?
                            <Dropdown >
                                <Dropdown.Toggle variant="success" id={item?.id?.toString()}>
                                    <i className="mdi icon-sm mdi-table-edit"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu alignRight style={{ zIndex: '999' }} >
                                    {
                                        arryactions ?
                                            arryactions.includes("Delete") ?
                                                <Dropdown.Item onClick={handleShow} style={{ color: 'red' }} >
                                                    حذف  <i className="mdi icon-sm mdi-delete"></i>
                                                </Dropdown.Item >

                                                : null

                                            : accessPage.includes("Delete") ?
                                                <Dropdown.Item onClick={handleShow} style={{ color: 'red' }} >
                                                    حذف  <i className="mdi icon-sm mdi-delete"></i>
                                                </Dropdown.Item >
                                                : null
                                    }

                                    {

                                        arryactions ?
                                            arryactions.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    ویرایش <i className="mdi mdi-pencil"></i>
                                                </Dropdown.Item>
                                                : null
                                            :
                                            accessPage.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    ویرایش <i className="mdi mdi-pencil"></i>
                                                </Dropdown.Item>

                                                : null
                                    }
                                    {
                                        urldata ? null
                                            :
                                            accessPage.includes("Update") ?
                                                <Dropdown.Item style={{ color: 'blue' }} onClick={() => handelview(item.id)}>
                                                    مشاهده <i className="mdi mdi-eye"></i>
                                                </Dropdown.Item>
                                                : null
                                    }
                                    {
                                        arryactions ?
                                            arryactions.includes("GetConfirm") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    وضعیت کار
                                                </Dropdown.Item>
                                                : null
                                            :
                                            accessPage.includes("GetConfirm") ?
                                                <Dropdown.Item style={{ color: 'green' }} onClick={() => handelEditbtn(item.id)}>
                                                    وضعیت کار
                                                </Dropdown.Item>

                                                : null
                                    }
                                    {arryactions ?
                                        arryactions.includes("Paid") ?
                                            <Dropdown.Item style={{ color: 'green' }} onClick={handelShowpaid}>
                                                پرداخت
                                            </Dropdown.Item>
                                            : null
                                        : accessPage.includes("Paid") ?
                                            <Dropdown.Item style={{ color: 'green' }} onClick={handelShowpaid}>
                                                پرداخت
                                            </Dropdown.Item>
                                            : null
                                    }
                                    {arryactions ?
                                        arryactions.includes("Confirm") ?
                                            <Dropdown.Item style={{ color: 'green' }} onClick={showConfermWorkerModal}>
                                                تایید نیرو
                                            </Dropdown.Item>
                                            : null
                                        : accessPage.includes("Confirm") ?
                                            <Dropdown.Item style={{ color: 'green' }} onClick={showConfermWorkerModal}>
                                                تایید نیرو
                                            </Dropdown.Item>
                                            : null
                                    }
                                    {arryactions ?
                                       arryactions.includes("GetPriceList") ?
                                            <Dropdown.Item style={{ color: 'green' }} onClick={handelShowModalPriceList}>
                                                لیست قیمت
                                            </Dropdown.Item>
                                            : null
                                        : accessPage.includes("GetPriceList") ?
                                            <Dropdown.Item style={{ color: 'green' }} onClick={handelShowModalPriceList}>
                                                لیست قیمت
                                            </Dropdown.Item>
                                            : null
                                    }

                                </Dropdown.Menu>
                            </Dropdown>
                            : null
                    }
                </td>
                <td>{number + 1}</td>
                {
                    keyarry.length > 0 ?
                        keyarry.length > 10 ?
                            keyarry.slice(0, 10).map((td, index) => (
                                index === 0 ? null :
                                    typeof td === 'boolean' ?
                                        <td key={index}>{td ? <i className="fa fa-check"></i>
                                            : <i className="fa fa-times"></i>}
                                        </td>
                                        : Object.keys(item)[index].search("Amount") > -1 || Object.keys(item)[index].search("amount") > -1 ?
                                            <td onClick={() => handelCopy(td)} key={index} >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 16 }).format(parseFloat(td))}</td>
                                            :
                                            Object.keys(item)[index].search("documentUrl") > -1 ?
                                                <td onClick={() => handelCopy(td)} key={index} ><a download href={td}>دانلود</a></td>
                                                :
                                                <td onClick={() => handelCopy(td)} key={index} >{td}</td>

                            ))

                            : keyarry.map((td, index) => (
                                index === 0 ? null :

                                    typeof td === 'boolean' ?
                                        <td key={index}>{td ? <i className="fa fa-check"></i>
                                            : <i className="fa fa-times"></i>}
                                        </td>
                                        : Object.keys(item)[index].search("Amount") > -1 || Object.keys(item)[index].search("amount") > -1 ?
                                            <td onClick={() => handelCopy(td)} key={index} >{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 16 }).format(parseFloat(td))}</td>
                                            :
                                            Object.keys(item)[index].search("documentUrl") > -1 ?
                                                <td onClick={() => handelCopy(td)} key={index} ><a href={`${td}`} target="_blank" download>دانلود</a></td>
                                                :
                                                <td onClick={() => handelCopy(td)} key={index} >{td}</td>
                            )) : null
                }
            </tr>
            {
                moreitem ?
                    <Row className='p-2' >
                        {
                            arryheder.map((HederHelmet, index) =>
                                <Col lg='12' md='12' sm='12' className='d-flex' >
                                    <p>{HederHelmet.label}</p>
                                    <span className='mr-1 ml-1'> : </span>
                                    {
                                        typeof keyarry[index + 10] === 'boolean' ?
                                            <p >{keyarry[index + 10] ? <i className="fa fa-check"></i>
                                                : <i className="fa fa-times"></i>
                                            }</p>
                                            : Object.keys(item)[index + 10].search("Amount") > -1 || Object.keys(item)[index].search("amount") > -1 ?
                                                <p onClick={() => handelCopy(keyarry[index + 10])} > {new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 16 }).format(parseFloat(keyarry[index + 10]))}</p>
                                                : <p onClick={() => handelCopy(keyarry[index + 10])} > {keyarry[index + 10]}</p>
                                    }
                                </Col>
                            )
                        }
                    </Row>

                    : null
            }
            {
                show ?
                    <ModalDelete showitem={show}
                        handeldeleteModal={handeldelete}
                        handleCloseMoudal={handleClose}
                        urldata={urldata}
                        id={item.id} />
                    : null
            }
            {
                showPiad ?
                    <ModalPaid
                        showitem={showPiad}
                        handeldeleteModal={handelPaiditem}
                        handleCloseMoudal={handelClosePaid}
                        handelModalepaid={handelModalepaid}
                        urldata={urldata}
                        id={item.id}
                    />
                    : null
            }
            {
                showmodalConferm ?
                    <ModalConfermWorker
                        show={showmodalConferm}
                        id={item.id}
                        urldata={urldata}
                        name={`${item.firstName} 
                       ${item.lastName}`}
                        handelClose={closeConfermWokerModal}
                        upDatae={handeldeleteitem}
                    />

                    : null
            }
            {
                showModalPriceList ? (
                    <ModalPriceList
                        showitem={showModalPriceList}
                        handleCloseMoudal={handelHideModalPriceList}
                        groupId={item.id}
                        groupTitle={item.title}
                    />
                ) : null}
        </>
    )
}




Tabelrowbody.propTypes = {

    item: PropTypes.object,
    /**مقدار ایندکس کامپوننت است که شماره نمایش است */
    number: PropTypes.number,
    /**برای بروز رسانی کامپوننت بالای است */
    handeldeleteitem: PropTypes.func,
    /**برای نمایش کامدال پرداخت است  وبروز رسانی است */
    handelModalepaid: PropTypes.func,
    /**ارایه هدر برای نمایش در جزئیات است */
    arryheder: PropTypes.array,
    /**مقدار ارسال داده است */
    urldata: PropTypes.string,
    /**ارایه دسترسی های کاربر است */
    arryactions: PropTypes.array,
}